<div class="card article-card">
  <div class="card-head">
    <img [src]="article.mainImage" onerror="this.onerror=null;this.src='../assets/images/no-image.svg'"
      alt="Article Image" class="mockup" />
  </div>
  <div class="card-body">
    <div class="time-span-info">
      <div class="tag-wrap">


        <span class="tag tag-success" *ngFor="let tag of article.tags">
          {{ "#" + tag }}
        </span>
      </div>
      <p class="date-log">
        {{ article.publishedOn | date : "MMM dd" : "UTC" }}
      </p>
    </div>
    <h4 class="card-title">{{article.title?.length >30? article.title?.substring(0,30)+'...' : article.title }}</h4>
    <h6 class="card-info">{{ article.description?.length >100? article.description?.substring(0,100)+'...' :
      article.description }}</h6>
    <div class="card-watch-data">
      <span class="profile-tag {{article?.accessLevelStyle}}">{{ article.accessLevelName }}</span>
      <ul>
        <li>
          <img src="../assets/images/ic-comments.svg" alt="Icon" />
          {{ article.commentCount }}
        </li>
        <li>
          <img src="../assets/images/ic-card-arrow-up.svg" alt="Icon" />
          {{ article.likeCount }}
        </li>
        <li>
          <img src="../assets/images/ic-card-arrow-down.svg" alt="Icon" />
          {{ article.dislikeCount }}
        </li>
      </ul>
    </div>
    <div class="post-uploader-data">
      By
      <div class="block">
        <img [src]="article.authorImageUrl" onerror="this.onerror=null;this.src='./assets/images/ic-user-default.svg'"
          alt="User" />
        {{ article.authorName }}
      </div>
    </div>
  </div>
</div>